module.exports = __webpack_public_path__ + "static/media/checkUp.0939883b.svg";